import Swiper from 'swiper/bundle'

/**
 * Slider functionality.
 * @author Dayne Coulson-Hoffacker
 */

export default class Slider {
  /**
     * Constructs a new Slider instance.
     * @param {Object} options - Options.
     * @param {HTMLElement} options.element - Container.
     */

  constructor(options) {
    this.element = options.element
    this.swiperContainer = this.element.querySelector('.swiper')
    this.swiperPagination = this.element.querySelector('.swiper-pagination')
    this.swiperButtonPrev = this.element.querySelector('[data-component="slider-button-prev"]')
    this.swiperButtonNext = this.element.querySelector('[data-component="slider-button-next"]')

    const breakpoint = window.matchMedia('(min-width:1024px)')
    let mySwiper

    const breakpointChecker = () => {
      if (breakpoint.matches === true) {
        if (!this.element.classList.contains('testimonials')) {
          if (mySwiper !== undefined) {
            mySwiper.destroy()
          }
        } else {
          return enableSwiper()
        }
        return;
      } else if (breakpoint.matches === false) {
        return enableSwiper()
      }
    }

    const enableSwiper = () => {

      if (this.element.classList.contains('testimonials')) {
        mySwiper = new Swiper(this.swiperContainer, {
          loop: true,
          autoHeight: true,
          spaceBetween: 0,
          slidesPerView: 1,
          breakpoints: {
            1024: {
              slidesPerView: 3,
              spaceBetween: 48
            }
          },
          pagination: {
            el: this.swiperPagination,
            clickable: true
          }
        })

        this.swiperButtonPrev.addEventListener('click', () => {
          mySwiper.slidePrev()
        })

        this.swiperButtonNext.addEventListener('click', () => {
          mySwiper.slideNext()
        })

      } else {
        mySwiper = new Swiper(this.swiperContainer, {
          loop: true,
          autoHeight: true,
          pagination: {
            el: this.swiperPagination,
            clickable: true
          }
        })
      }

    }

    breakpoint.addEventListener('change', breakpointChecker)

    breakpointChecker()

  }
}
